import { useQuery } from 'react-query'
import { axiosClientAuth } from '../utils/axiosClient'

export type KybStatusValue = 'PENDING_REVIEW' | 'ACCEPTED' | 'REJECTED'

export interface KybAuditEvent {
  event_type: string
  actor: string
  message: string
  meta: any
  created_at: string
}

export interface KybDecision {
  reason?: string
  outcome?: string
  decided_at?: string
  decided_by_user_id?: number
  decided_by_operator?: string
}

export interface KybDocument {
  document_id: string
  document_type: string
  s3_object_uri: string
  file_name: string
  status: string
  uploaded_at: string
}

export interface KybStatusData {
  id: string
  account_id?: string
  registration_number: string
  email: string
  business_name: string
  brand_name: string
  resource_type: string
  business_type: string
  category: string
  country: string
  address_line1: string
  address_line2: string
  city: string
  state: string
  zip_code: string
  authorised_person_name: string
  department: string
  contact_phone: string
  status: KybStatusValue
  decision: KybDecision | null
  documents: KybDocument[]
  resubmission_count: number
  audit_log: KybAuditEvent[]
  created_at: string
  updated_at: string
}

const fetchKybStatus = async (): Promise<KybStatusData | null> => {
  const res = await axiosClientAuth.get('/kyb/status/', {
    transformResponse: [
      (data: string) => {
        const safe = data.replace(/"account_id"\s*:\s*(\d+)/g, '"account_id": "$1"')
        return JSON.parse(safe)
      },
    ],
  })
  return res.data?.data ?? null
}

export const useKybStatus = () =>
  useQuery<KybStatusData | null>('kyb-status', fetchKybStatus, {
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  })
